export enum TemplateTypeEnum {
    Unifi = 'UNIFI',
    Ermc = 'ERMC',
    Scrub = 'SCRUB',
    Uaie = 'UAIE',
    Uauk = 'UAUK',
    Pias = 'PIAS'
}